/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScheduleTemplateListFilter, ScheduleType } from '@gh/builder-shared-data';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';

import { EnumDictionary, FormState, FormStateBuilder, getDialogInitData } from '@gh/common-shared';
import { observableBasedSlicedDataSource, SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';

import { ScheduleTemplatesFinderBusinessService } from '../../resources/schedule-template-finder-business.service';
import {
  ScheduleTemplateFinderDialogConfig,
  ScheduleTemplateListItem,
} from '../../resources/schedule-template-finder.model';
import { ScheduleTemplateFinderDialogGridDefinition } from './schedule-template-finder-dialog-grid-definition.service';

@Component({
  selector: 'gh-schedule-template-finder-dialog',
  template: require('./schedule-template-finder-dialog.component.html'),
  styles: [require('./schedule-template-finder-dialog.component.scss')],
  providers: [ScheduleTemplateFinderDialogGridDefinition],
})
export class ScheduleTemplateFinderDialogComponent
  extends AbstractFinderDialogComponent<ScheduleTemplateFinderDialogConfig, ScheduleTemplateListItem>
  implements OnInit {

  form: FormState<any>;
  defaultTitle = this.translations.get('lbl_find_schedule_templates');
  scheduleType: EnumDictionary<ScheduleType>;

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              public gridDefinition: ScheduleTemplateFinderDialogGridDefinition,
              private translations: TranslationService,
              private formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>, // any?
              private businessService: ScheduleTemplatesFinderBusinessService) {
    super(dialogRef);

    const { scheduleType } = getDialogInitData(this.dialogData);
    this.scheduleType = scheduleType;

  }

  getId = ({ id }: ScheduleTemplateListItem) => id;

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value: {
        showConstructionTemplates: true,
        showSalesTemplates: true,
        showPreConstructionsTemplates: true,
        showMaintenanceTemplates: true,
      },
      children: {
        searchString: void 0,
        showConstructionTemplates: void 0,
        showSalesTemplates: void 0,
        showPreConstructionsTemplates: void 0,
        showMaintenanceTemplates: void 0,
      },
    });

    super.ngOnInit();
  }

  protected buildDataSource(filter: ScheduleTemplateListFilter): SlicedDataSource<ScheduleTemplateListItem> {
    const scheduleTemplateList$ = this.businessService.findAllByOffice(this.form.submitValue);
    return observableBasedSlicedDataSource<ScheduleTemplateListItem>(scheduleTemplateList$);
  }
}
